<template>
<div>
	<v-container>
		<v-row>
			<v-col class="headline" cols="12" >
				Development mode:
				<span v-if="dev === ''"></span>
				<span v-else-if="dev" class="red--text">On</span>
				<span v-else class="green--text">Off</span>
			</v-col>
			<v-col class="headline" cols="12" >
				Restricted mode:
				<span v-if="restricted === ''"></span>
				<span v-else-if="restricted" class="red--text">On</span>
				<span v-else class="green--text">Off</span>
			</v-col>
			<v-col cols="6">
				<v-row >
					<v-col cols="4">
						<v-btn
							@click="open('https://dev-api-reports.ifk-hm.com/debug/debug.html')"
							color="primary"
							block>
							DEBUG DEV
						</v-btn>
					</v-col>
					<v-col cols="4">
						<v-btn
							@click="open('https://dev-api-reports.ifk-hm.com/debug/errors.html')"
							color="secondary"
							block>
							ERRORS DEV
						</v-btn>
					</v-col>
					<v-col cols="4">
						<v-btn
							@click="open('https://dev-api-reports.ifk-hm.com')"
							color="secondary"
							block>
							COMPILATION DEV
						</v-btn>
					</v-col>
					<v-col cols="12">
					</v-col>
					<v-col cols="4">
						<v-btn
							@click="open('https://api-reports.ifk-hm.com/debug/debug.html')"
							color="primary"
							block>
							DEBUG
						</v-btn>
					</v-col>
					<v-col cols="4">
						<v-btn
							@click="open('https://api-reports.ifk-hm.com/debug/errors.html')"
							color="secondary"
							block>
							ERRORS
						</v-btn>
					</v-col>
					<v-col cols="4">
						<v-btn
							@click="open('https://api-reports.ifk-hm.com')"
							color="secondary"
							block>
							COMPILATION
						</v-btn>
					</v-col>
					<v-col cols="12">
					</v-col>
					<v-col cols="4">
						<v-btn
							@click="testEmail"
							color="primary"
							class="my-3"
							block>
							Test email
						</v-btn>
					</v-col>
					<v-col cols="8">
						<v-text-field
							v-model="email"
							single-line>
						</v-text-field>
					</v-col>
					<v-col cols="6">
						<v-btn
							@click="callTest"
							color="primary"
							block>
							Call test
						</v-btn>
					</v-col>
					<v-col cols="6">
					</v-col>
					<v-col cols="6">
						<v-btn
							@click="callTestMultiple"
							color="primary"
							class="my-3"
							block>
							Call test multiple
						</v-btn>
					</v-col>
					<v-col cols="6">
						<v-text-field
							v-model="multipleCallsCount"
							single-line>
						</v-text-field>
					</v-col>
					<v-col cols="12" v-if="specialActionName.length">
						<v-btn
							@click="specialAction"
							color="secondary"
							block>
							{{ specialActionName }}
						</v-btn>
					</v-col>
					<v-col cols="12">
						<v-btn
							@click="copyDevToApi"
							color="secondary"
							block>
							COPY CODE: DEV >> PRODUCTION
						</v-btn>
					</v-col>
					<v-col cols="12">
						<v-btn
							@click="copyProdDbToTestDb"
							color="secondary"
							block>
							COPY DATABASE: TEST &lt;&lt; PRODUCTION
						</v-btn>
					</v-col>
					<v-col cols="8">
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6">
				<v-row v-for="log in logsCron" :key="log.path">
					<v-col cols="12" >

						<v-alert dense :type="log.alert ? 'error' : 'success'">
							{{ log.path }} - {{ log.time }}
						</v-alert>

					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
	<v-dialog v-model="multipleCallsDialog"
		max-width="600"
		persistent>
		<v-card>
			<v-card-title class="headline">
				Api ответил
			</v-card-title>

			<v-card-text>
				<v-row>
					<v-col cols="3">
						Номер
					</v-col>
					<v-col cols="3">
						Время с начала
					</v-col>
					<v-col cols="3">
						Время
					</v-col>
					<v-col cols="3">
						Ответ
					</v-col>
				</v-row>
				<v-row v-for="(line, i) in multipleCallsOutput" :key="i">
					<v-col cols="3">
						Ответ {{ i + 1 }}
					</v-col>
					<v-col cols="3">
						{{ line.time }}
					</v-col>
					<v-col cols="3">
						{{ line.timeDiff }}
					</v-col>
					<v-col cols="3">
						{{ line.response }}
					</v-col>
				</v-row>
			</v-card-text>

			<v-card-actions class="pa-4">
				<v-btn color="primary" @click="multipleCallsDialog = !multipleCallsDialog">
					Закрыть
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<style scoped>

</style>

<script>
	import {api} from '../../lib/api'
	import _ from 'lodash'

	export default {
		components: {
		},
		data: () => ({
			restricted: '',
			dev: '',
			email: 'maxim.izmaylov@ifk-hm.com',
			multipleCallsOutput: [],
			multipleCallsCount: 5,
			multipleCallsDialog: false,
			specialActionName: 'Специальное действие',
			logsCron: []
		}),
		computed: {

		},
		created() {
			this.checkRestricted()
			this.checkDev()
			this.whatSpecialAction()
			this.checkCron()
		},
		mounted() {

		},
		methods: {
			checkCron() {
				api.post('cron/check')
				.then(response => {
					this.logsCron = response.data.data
				}, error => {})
			},
			checkRestricted() {
				api.post('admin/check_restricted')
				.then(response => {
					this.restricted = response.data.restricted
				}, error => {})
			},
			checkDev() {
				api.post('admin/check_dev')
				.then(response => {
					this.dev = response.data.dev
				}, error => {})
			},
			testEmail() {
				api.post('admin/test_mail', {
					to: this.email
				})
				.then(response => {
					this.$store.dispatch('dialogNotify', {
						title: 'Успешно',
						message: 'Письмо отправлено'
					})
				}, error => {})
			},
			callTest() {
				this.$store.dispatch('dialogLoadingStart')
				api.post('admin/test')
				.then(response => {
					this.$store.dispatch('dialogLoadingStop')
					this.$store.dispatch('dialogNotify', {
						title: 'Test Api ответил успешно',
						message: response.data.message
					})
				}, error => { this.$store.dispatch('dialogLoadingStop') })
			},
			whatSpecialAction() {
				api.post('admin/special_action', {
					whatAction: true
				})
				.then(response => {
					this.specialActionName = response.data.message
				}, error => {})
			},
			specialAction() {
				this.$store.dispatch('dialogLoadingStart')
				api.post('admin/special_action')
				.then(response => {
					this.$store.dispatch('dialogLoadingStop')
					this.$store.dispatch('dialogNotify', {
						title: 'Специальное действие выполнено',
						message: response.data.message
					})
				}, error => { this.$store.dispatch('dialogLoadingStop') })
			},
			updatePlStatuses() {
				api.post('admin/pl_update_statuses')
				.then(response => {
					this.$store.dispatch('dialogNotify', {
						title: 'Успешно',
						message: response.data.message
					})
				}, error => {})
			},
			callTestMultiple() {
				let date = new Date()
				let calls = this.multipleCallsCount
				let prevTime = 0
				this.multipleCallsOutput = []

				for(let i = 0; i < calls; i++) {
					api.post('admin/test', {
						number: i
					})
					.then(response => {
						let timeNow = new Date() - date
						this.multipleCallsOutput.push({
							response: response.data.success ? response.data.message : response.data.error,
							time: timeNow,
							timeDiff: timeNow - prevTime
						})
						prevTime = timeNow
					}, error => {})
				}

				this.multipleCallsDialog = true
			},
			copyDevToApi() {
				this.$store.dispatch('dialogConfirm', {
					title: 'Копирование в продакшн',
					message: 'Вы уверены?'
				})
				.then(confirm => {
					if (confirm) {
						this.$store.dispatch('dialogLoadingStart')
						api.post('admin/copy_dev_to_api')
						.then(response => {
							this.$store.dispatch('dialogLoadingStop')
							this.$store.dispatch('dialogNotify', {
								title: 'Копирование завершено',
								message: 'Копирование заняло ' + response.data.time + ' секунд'
							})
						}, error => { this.$store.dispatch('dialogLoadingStop') })
					}
				}, error => {})
			},
			copyProdDbToTestDb() {
				this.$store.dispatch('dialogConfirm', {
					title: 'Копирование рабочей базы данных в тестовую',
					message: 'Вы уверены?'
				})
				.then(confirm => {
					if (confirm) {
						this.$store.dispatch('dialogLoadingStart')
						api.post('admin/copy_prod_db_to_test')
						.then(response => {
							this.$store.dispatch('dialogLoadingStop')
							this.$store.dispatch('dialogNotify', {
								title: 'Копирование завершено',
								message: 'Копирование заняло ' + response.data.time + ' секунд'
							})
						}, error => { this.$store.dispatch('dialogLoadingStop') })
					}
				}, error => {})
			},
			open(url) {
				window.open(url)
			}
		}
	}
</script>
